import React, { useEffect, useState } from "react";
import { ProjectData, projectsNav } from "./Data";
import ProjectItem from "./ProjectItem";

const ProjectInfo = () => {
  const [item, setItem] = useState({ name: "All" });
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (item.name === "All") {
      setProjects(ProjectData);
    } else {
      const newProjects = ProjectData.filter((project) => {
        return project.category === item.name;
      });

      setProjects(newProjects);
    }
  }, [item]);

  const handleClick = (e, index) => {
    setItem({ name: e.target.textContent });
    setActive(index);
  };

  return (
    <div>
      <div className="work_filters">
        {projectsNav.map((item, index) => {
          return (
            <span
              onClick={(e) => {
                handleClick(e, index);
              }}
              className={`${active === index ? "active-work" : ""} work_item`}
              key={index}
            >
              {item.name}
            </span>
          );
        })}
      </div>

      <div className="work_container container grid">
        {projects.map((item, index) => {
          return <ProjectItem item={item} key={item.id} />;
        })}
      </div>
    </div>
  );
};

export default ProjectInfo;
